import { Theme } from "@mui/material/styles";

export const container = (theme: Theme) => ({
    position: "relative",
});

export const box = (theme: Theme) => ({
    position: "absolute",
    zIndex: 99,
    top: 46,
    boxShadow: `0rem 0.25rem 0.375rem -0.0625rem rgb(0 0 0 / 10%),
     0rem 0.125rem 0.25rem -0.0625rem rgb(0 0 0 / 6%)`,
    padding: "15px 10px",
    backgroundColor: "#ffffff",
    width: "100%",
    maxHeight: 220,
    borderRadius: 2,
});

export const scrollBox = (theme: Theme) => ({
    maxHeight: 134,
    overflowY: "auto",
});

export const listItem = (theme: Theme, ownerState: { isAdd?: boolean, isOrder?: boolean }) => {
    const { isAdd = false, isOrder = false } = ownerState;
    return ({
        padding: "6px 16px",
        borderRadius: 2,
        fontFamily: "Open Sans",
        color: "#344767",
        fontSize: "0.875rem",
        fontWeight: 400,
        "&:hover": {
            backgroundColor: "#f3f3f3",
            color: "#000000",
            transition: "color 100ms linear",
            cursor: "pointer",
            "-webkit-transition": "color 100ms linear",
        },
        ...(isAdd && {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderTop: "1px solid #f3f3f3",
        }),
        ...(isOrder && {
            padding: "6px 10px",
        })
    })
};

export const listOrderItem = (theme: Theme) => ({
    padding: "6px 10px",
});

export const addItem = (theme: Theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderTop: "1px solid #f3f3f3",
});
